import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/src/app/global-error.tsx");
